import styled from 'styled-components';

export const ScriptHeader = styled.h3`
    font-family: ${props => props.theme.sansSerif};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 120%;
    color: #0A1E28;
    position: static;
    width: 288px;
    left: calc(50% - 288px/2);
    top: 0%;
    bottom: 32%;
`;

export const ScriptSection = styled.div`
    background-color: ${props => props.theme.darkGrey};
    padding: 16px;
`;

export const HighlightSection = styled.div`
    background-color: yellow;
    padding: 2px 8px;
    ${props => props.underline && 'text-decoration: underline;'}
`;
